<template>
  <div class="border">
    <h4>{{ "transactions" | setText("Продажи") }}</h4>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :fields="fields"
      :searchDisable="true"
      :openItem="false"
      @updated="$emit('updated', true)"
      @added="$emit('added', true)"
      @change="change"
      @input="change"
      @changeFunction="changeFunction"
      @deleted="$emit('deleted', true)"
      v-model="val"
    />
  </div>
</template>
<script>
export default {
  name: "products",
  props: {
    id: {
      default: null,
    },
  },
  created() {
    this.itemLink = `orders/${this.id}/transactions`;
    this.setLink = `orders/${this.id}/transactions`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "purchase",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "partner",
          label: "Партнер",
          type: "select",
          modal: "partner",
          selectKey: "name",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_transaction",
      itemLink: "orders",
      setLink: "orders",
      columns: [
        {
          key: "exchange_id",
          title: "ID Партнера",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "partner",
          titleKey: "partner",
          title: "Партнер",
          object: "name",
          checkbox: false,
          disableLink: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "status",
          titleKey: "status",
          title: "Статус",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "month",
          titleKey: "month",
          title: "Срок (месяц)",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "client_confirmed",
          titleKey: "client_confirmed",
          title: "Клиент",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "system_confirmed",
          titleKey: "system_confirmed",
          title: "Система",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "created_at",
          titleKey: "created_at",
          checkbox: false,
          control: false,
          align: "right",
          dateTimeFormat: true,
          detail: false,
        },
      ],
    };
  },
};
</script>
